export default {
  POSITIVE_NUMBER: /^[.]?[0-9]+[.]?[0-9]*$/,
};
  